const firstNumber = (...values) => {
  for (const value of values) {
    if (value !== undefined && value !== null && value !== '' && Number.isFinite(Number(value))) {
      return Number(value);
    }
  }
  return null;
};

export const operationalScopeOf = (item, operationsCountry = 'Operations Area') => {
  const value = item?.operational_scope || item?.location?.operational_scope;
  const explicitCode = typeof value === 'string' ? value : value?.code;
  let code = String(explicitCode || '').trim().toLowerCase();
  if (!['internal', 'external', 'unresolved'].includes(code)) {
    const legacyInternal = item?.internal ?? item?.location?.internal;
    if (legacyInternal === true) code = 'internal';
    else if (legacyInternal === false) code = 'external';
    else code = 'unresolved';
  }
  const country = String(
    (typeof value === 'object' && (value?.country_name || value?.operations_country_name)) ||
    operationsCountry ||
    'Operations Area'
  ).trim();
  const distance = firstNumber(
    typeof value === 'object' ? value?.distance_to_operations_area_km : null,
    item?.location?.distance_km,
    item?.distance_km
  );
  const authoritativeLabel = String(
    typeof value === 'object' ? value?.label || '' : ''
  ).trim();
  const authoritativeReason = String(
    typeof value === 'object' ? value?.reason || value?.detail || '' : ''
  ).trim();
  return {
    code,
    country,
    distance,
    label: authoritativeLabel || (
      code === 'internal'
        ? 'Internal'
        : code === 'external'
          ? 'External'
          : 'Scope unresolved'
    ),
    detail: authoritativeReason || (
      code === 'internal'
        ? `Inside ${country}`
        : code === 'external'
          ? `Outside ${country}`
          : 'Location boundary not yet verified'
    ),
  };
};

export const uniqueEventAreaLabels = (values, operationsCountry = '') => {
  const operationsAnchor = `${operationsCountry} operations area`.trim().toLocaleLowerCase();
  const seen = new Set();
  return (values || []).flat().filter((value) => {
    const label = String(value || '').trim();
    const key = label.toLocaleLowerCase();
    if (
      !label ||
      seen.has(key) ||
      key === operationsAnchor ||
      key === 'operations area'
    ) return false;
    seen.add(key);
    return true;
  });
};
